<!-- Launcher: bottom-left floating button (hidden while the panel or pill is showing) -->
<button *ngIf="!open" type="button" class="assistant-fab" (click)="toggle()"
        matTooltip="Bill - Billing Assistant" matTooltipPosition="right" aria-label="Open Bill, the billing assistant">
    <span class="material-symbols-outlined">smart_toy</span>
</button>

<!-- Minimized pill: the conversation stays alive but Bill stops covering the page -->
<button *ngIf="open && minimized" type="button" class="assistant-pill" (click)="restore()"
        matTooltip="Restore Bill" matTooltipPosition="right" aria-label="Restore the assistant panel">
    <span class="material-symbols-outlined">smart_toy</span>
    <span class="assistant-pill-label">Bill</span>
    <span *ngIf="sending" class="assistant-pill-busy" aria-label="Bill is working"></span>
</button>

<!-- Chat panel -->
<div *ngIf="open && !minimized" class="assistant-panel">
    <!-- Two header rows so the full title always fits and the Autonomous QA toggle stays
         visible on every screen size (it used to share the title row and got hidden on phones). -->
    <div class="assistant-header">
        <div class="assistant-header-row">
            <span class="material-symbols-outlined assistant-header-icon">smart_toy</span>
            <span class="assistant-title">Bill - Billing Assistant</span>

            <button type="button" class="assistant-header-btn" (click)="clear()"
                    matTooltip="Clear conversation" aria-label="Clear conversation" [disabled]="sending || messages.length === 0">
                <span class="material-symbols-outlined">delete_sweep</span>
            </button>
            <button type="button" class="assistant-header-btn" (click)="minimize()"
                    matTooltip="Minimize - keeps the conversation" aria-label="Minimize the assistant">
                <span class="material-symbols-outlined">remove</span>
            </button>
            <button type="button" class="assistant-header-btn assistant-close" (click)="toggle()"
                    matTooltip="Close" aria-label="Close the assistant">
                <span class="material-symbols-outlined">close</span>
            </button>
        </div>

        <div *ngIf="showAutoQaToggle" class="assistant-header-sub">
            <mat-slide-toggle class="assistant-autoqa"
                              [checked]="autoQa" (change)="onAutoQaChange($event.checked)"
                              matTooltip="Let the assistant QA and approve billings on its own when it is confident">
                Autonomous QA
            </mat-slide-toggle>
        </div>
    </div>

    <div *ngIf="status && !status.configured" class="assistant-banner">
        Not configured - an Anthropic API key must be added by an administrator.
    </div>

    <div #messageList class="assistant-messages">
        <div *ngIf="messages.length === 0 && (!status || status.configured)" class="assistant-empty">
            Hi, I'm Bill. Ask me anything about billing - timesheets, codes, rates, revenue, QA
            history, provisions. Teach me durable rules with "remember: ..." and I will apply them
            going forward.
        </div>

        <div *ngFor="let m of messages" class="assistant-msg" [class.from-user]="m.role === 'user'">
            <div class="assistant-bubble">{{ m.content }}</div>
            <div *ngIf="m.actions?.length" class="assistant-actions">
                <div *ngFor="let a of m.actions" class="assistant-action" [class.failed]="!a.success">
                    <mat-icon class="assistant-action-icon">{{ a.success ? 'task_alt' : 'error_outline' }}</mat-icon>
                    <span>{{ a.success ? 'Applied' : 'Failed' }}: {{ a.summary }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="sending" class="assistant-msg">
            <div class="assistant-bubble assistant-typing">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
            </div>
        </div>
    </div>

    <div class="assistant-input">
        <textarea [(ngModel)]="draft" (keydown)="onKeydown($event)" rows="2"
                  placeholder="Ask a billing question..."
                  [disabled]="sending || status?.configured === false"></textarea>
        <button mat-icon-button type="button" color="primary" (click)="send()"
                [disabled]="sending || !draft.trim() || status?.configured === false" aria-label="Send">
            <mat-icon>send</mat-icon>
        </button>
    </div>
</div>
